<template>
  <div class="qr_code">
    <div class="content">
      <p class="header_img" v-if="memberInfo.infos"><img :src="memberInfo.infos.head_pic" @error="defaultAvatar()" /></p>
      <p class="name">{{memberInfo.nickname}}</p>
      <img class="qrcode" :style="codestyle" :src="code" @error="defaultPro()" />
      <p class="tip"><span>扫码</span>立即<span>注册</span>销巴生活账号</p>
      <p class="tip">开启消费养老时代</p>
    </div>
  </div>
</template>
<script>
import avatarDefault from '@/assets/common/avatar.png';
import productDefault from '@/assets/common/preload.png';
export default {
  data() {
    return {
      memberInfo: {},
      share_Url: '',
      code:'',
      codestyle:{
	      height: document.body.clientWidth - 80 + 'px'
	    }
    };
  },
  created (){
  	var baseUrl = window.location.href.split(this.$route.path)
		this.$api.setToken(this.$route.query.token);
    this.share_Url = baseUrl[0]+'/share?shareCode='+this.$route.query.shareCode+'&mobile='+this.$route.query.mobile;
    this.getInfo();
		this.getCode();
  },
  methods: {
    getInfo() {
        this.$api.get("/member/member/user/detail").then(res => {
          if(res.infos) {
            res.infos.head_pic = res.infos.head_pic || 'aaa.png';
          }
	        this.memberInfo = res;
    	}).catch(err => {
	        let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0]
	  		if(message.slice(0, 10) == 'timeout of') {
	  			this.$toast('网络不给力，请稍候重试');
	  		}else {
	  			this.$toast(message);
	  		}
      });  
    },
  	getCode() {
    	this.$api.post("/member/member/member/qrcode",{url:this.share_Url}).then(res => {
          if(res.img) {
            this.code = res.img;
          }else {
            this.$api.post("/membe/member/rmember/update/qrcode").then(res => {
              this.code = res.share_code;
            });
          }
	    });
    },
    defaultAvatar() {
      var img = event.srcElement;
		  img.src = avatarDefault;
		  img.onerror = null; //防止闪图
    },
    defaultPro() {
	  	var img = event.srcElement;
		  img.src = productDefault;
		  img.onerror = null; //防止闪图
	  }
  },
//mounted() {
//}
  
};
</script>
<style lang="less" scoped>
.qr_code {
  min-height: 100%;
  padding: 30px 30px 0;
  box-sizing: border-box;
  background: -webkit-linear-gradient(#FD786E, #FFB785); /* Safari 5.1 - 6.0 */
  background: -o-linear-gradient(#FD786E, #FFB785); /* Opera 11.1 - 12.0 */
  background: -moz-linear-gradient(#FD786E, #FFB785); /* Firefox 3.6 - 15 */
  background: linear-gradient(#FD786E, #FFB785); /* 标准的语法（必须放在最后） */
  .content {
    height: auto;
    background: #ffffff;
    border-radius: 20px;
    padding: 30px 10px 40px;
    .header_img {
      text-align: center;
      img {
        display: inline-block;
        width: 60px;
        height: 60px;
        border-radius: 30px;
      }
    }
    .name {
      color: #333;
      font-size: 17px;
      text-align: center;
      height: 24px;
      line-height: 24px;
      margin-top: 10px;
      margin-block: 20px;
      font-weight: bold;
    }
    .qrcode {
      width: 100%;
      margin-bottom: 10px;
    }
    .tip {
      color: #999999;
      font-size: 15px;
      text-align: center;
      line-height: 21px;
      span {
        color: #FF6059;
      }
    }
  }
}

</style>


